import { createAction } from '@reduxjs/toolkit';
import { asyncActionsCreator } from '../../global/redux';
import * as constants from './constants';

export const getSalesProducts = asyncActionsCreator(
  constants.GET_SALES_PRODUCTS
);
export const updateSalesProduct = asyncActionsCreator(
  constants.UPDATE_SALES_PRODUCT
);

export const getProductsBySku = asyncActionsCreator(
  constants.GET_PRODUCTS_BY_SKU
);
export const updateCost = asyncActionsCreator(constants.UPDATE_COST);
export const deleteProduct = asyncActionsCreator(constants.DELETE_PRODUCT);
export const createNewSaleOrder = asyncActionsCreator(
  constants.CREATE_NEW_ORDER
);
export const clearCreateErrors = createAction(constants.CLEAR_CREATE_ERRORS);
export const getAllSalesProducts = asyncActionsCreator(
  constants.GET_ALL_SALES_PRODUCTS
);
export const getProductsInfo = asyncActionsCreator(constants.GET_PRODUCTS_INFO);

export const getNewSearchProducts = asyncActionsCreator(
  constants.GET_NEW_SEARCH_PRODUCTS
);
